import React from 'react';
import { useSelector } from 'react-redux';
import { Entity } from '@debbie/common/dist/index.js';
import { getCollectorOnCase } from '@debbie/common/dist/cases/index.js';
import { courts } from '@debbie/common/dist/court/index.js';
import { getContactPerson } from '@debbie/common/dist/customers/index.js';
import Inbox from '../Icons/Inbox.js';
import EmailInteraction from './EmailInteraction.js';
import RecipientContent from './RecipientContent.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useCollector } from '@debbie/cortex/dist/collectors/index.js';
import { useEmailServer } from '@debbie/cortex/dist/email-servers/index.js';
const Court = (props) => {
    const creditorLoadable = useCreditor(props.case.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const collectorLoadable = useCollector((props.case &&
        creditor &&
        getCollectorOnCase(props.case.type, props.case.collectorId, creditor.identityCollectorId, creditor.defaultCollectorId)) ||
        undefined);
    const collector = h.hasData(collectorLoadable) ? collectorLoadable.data : null;
    const emailServerLoadable = useEmailServer(collector?.emailServerId);
    const emailServer = h.hasData(emailServerLoadable)
        ? emailServerLoadable.data
        : null;
    const lang = useSelector((s) => s.lang);
    const contactPerson = getContactPerson(props.customer);
    const court = contactPerson?.details.courtId &&
        courts.find((c) => c.id === contactPerson?.details.courtId);
    const emailTo = court && court.email;
    const tabs = [
        {
            children: (React.createElement(EmailInteraction, { referenceId: props.case.caseId, referenceType: Entity.Case, isCourt: true, emailTo: emailTo })),
            className: 'ui-test-d77b5bf4',
            icon: Inbox,
            label: lang.interactionTypes.EMAIL,
            shouldHide: !emailTo || !emailServer,
        },
    ];
    return React.createElement(RecipientContent, { tabs: tabs });
};
export default Court;
//# sourceMappingURL=Court.js.map